import ImagePlacements from './ImagePlacements'

export default ImagePlacements